import { Injectable, signal } from '@angular/core';
import { Theme } from '../models/theme.model';
import { effect } from '@angular/core';
import { AuthService } from './auth.service';
import { BaseService } from './base.service';
import { CryptoExtension } from '../utils/crypto.extension';

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    public theme = signal<Theme>({ mode: 'light', color: 'blue' });
    currentEmployee: any;
    constructor(
        private _authService: AuthService,
        private _baseService: BaseService,
    ) {
        this.currentEmployee = _authService.getUserFromLocalStorage();
        this.loadTheme();
        effect(() => {
            this.setTheme();
        });
    }

    private loadTheme() {
        if (this.currentEmployee?.ThemeConfig) {
            try {
                const themeConfig = JSON.parse(this.currentEmployee.ThemeConfig);
                if (this.isValidTheme(themeConfig)) {
                    this.theme.set(themeConfig);
                }
            } catch (error) {
                this.setTheme();
                console.error("Error parsing ThemeConfig:", error);
                // Có thể thêm xử lý lỗi ở đây, ví dụ: đặt theme mặc định
            }
        }
    }
    private isValidTheme(theme: any): theme is Theme {
        return theme && typeof theme.mode === 'string' && typeof theme.color === 'string';
    }

    private setTheme() {
        if (this.currentEmployee) {
            const updatedTheme = JSON.stringify(this.theme());
            this._baseService.getDataAPI("UpdateData", {
                tbname: "aHd2XU255G+9SN+qeDwVlQ==",
                rows: {
                    ID: this.currentEmployee.ID,
                    ThemeConfig: updatedTheme,
                    state: 1
                }
            }).subscribe({
                next: () => {
                    this.currentEmployee.ThemeConfig = updatedTheme;
                    this._authService.setUserFromLocalStorage(this.currentEmployee);
                },
                error: (err) => console.error('Lỗi khi cập nhật chủ đề:', err)
            });
        }
        this.setThemeClass();
    }


    public get isDark(): boolean {
        return this.theme().mode == 'dark';
    }

    private setThemeClass() {
        document.querySelector('html')!.className = this.theme().mode;
        document.querySelector('html')!.setAttribute('data-theme', this.theme().color);
    }
}
